import React, { useState } from 'react';
import styles from './Card.module.scss';
import PdfIcon from 'src/assets/icons/material-pdf.svg?react';
import DownloadIcon from 'src/assets/icons/download.svg?react';
import PrintIcon from 'src/assets/icons/material_print.svg?react';
import { Content } from '@src/api/graphql-codegen';
import Button from '../button/Button';
import { downloadFile } from '@src/services/File';

type Props = {
  content: Content
  handleDownloadMaterial?: (content: Content) => void;
  handlePrintMaterial?: (content: Content) => void;
}

function MaterialCard(props: Props) {
  const { content, handleDownloadMaterial, handlePrintMaterial } = props

    const [downloading, setDownloading] = useState(false);

  const handleDownload = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    if (content.data) {
      setDownloading(true);
      downloadFile(content.data, 'pdf')
        .catch(() => {
          alert(`Can't download file.`);
        })
        .finally(() => {
          setDownloading(false);
        });
    }
  }

  const handleOpenMaterial = () => {
    handleDownloadMaterial?.(content)
  }

  const handlePrint = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    handlePrintMaterial?.(content)
  }

  return (
    <div className={styles.card} onClick={handleOpenMaterial}>
      <PdfIcon />
      <div className={styles.title}>{content.name}</div>
      <Button label='' disabled={downloading} className={styles.printBtn} leftIcon={<PrintIcon className={styles.printIcon} />} onClick={handlePrint}/>
      <Button label='' disabled={downloading} className={styles.downloadBtn} leftIcon={<DownloadIcon className={styles.downloadIcon} />} onClick={handleDownload}/>
    </div>
  );
}

export default MaterialCard

